import { Button } from '@hivebrite/design-system/Button';
import {
  ButtonInLink,
  type ButtonInLinkProps,
} from '@hivebrite/design-system/ButtonInLink';

interface AppHeaderLinkButtonProps {
  label: string;
  isPreview?: boolean;
  url: string;
  variant?: ButtonInLinkProps['variant'];
  target?: string;
}

const AppHeaderLinkButton = ({
  label,
  isPreview = false,
  url,
  variant = 'primary',
  target,
}: AppHeaderLinkButtonProps) => {
  if (isPreview) {
    return (
      <Button variant={variant} isFullWidth>
        {label}
      </Button>
    );
  }

  return (
    <ButtonInLink linkProps={{ to: url, target }} variant={variant} isFullWidth>
      {label}
    </ButtonInLink>
  );
};

export default AppHeaderLinkButton;
